// ============================================================================
// src/ecrituresActivite.js : les fiches projet et les réunions s'écrivent par
// le serveur pour ce qui ouvre des droits (décision de Pierre du 20/10/2026)
// ============================================================================
// Étape 1 de la fermeture des règles de `projects` et `reunions`
// (docs/exploitation/regles-projets-reunions.md). Créer, supprimer, changer
// un porteur, un contact de distribution, une mutuelle porteuse, un invité,
// l'organisateur, répondre à une réunion, demander à y participer : par les
// fonctions projetEcrire et reunionEcrire (functions/activiteEcritures.js,
// Francfort, jeton Aramis exigé). Le serveur relit le document et le droit
// de l'appelant ; l'écran ne décide plus de rien.
// ============================================================================
import { REGION_FRANCFORT } from "./regionsFonctions";

async function appeler(nom, data) {
  const { getFunctions, httpsCallable } = await import("firebase/functions");
  try {
    const res = await httpsCallable(getFunctions(undefined, REGION_FRANCFORT), nom, { timeout: 60000 })(data);
    return res.data || {};
  } catch (e) {
    // Défi (jeton manquant ou échu) : la bannière de reconnexion s'affiche.
    try { const g = await import("./authGuard"); g.signalerSiDefi(e); } catch {}
    const m = String((e && e.message) || "").replace(/^[a-z-]+:\s*/i, "").trim();
    throw Object.assign(new Error(m && !/^internal$/i.test(m) ? m : "Enregistrement impossible pour le moment. Réessayez."), { code: e && e.code });
  }
}

/** Fiche projet : enregistrer (fiche entière, avec son état d'ouverture), modifier, rattacher, supprimer. */
export const projetEcrire = (action, data = {}) => appeler("projetEcrire", { ...data, action });
/** Réunion : enregistrer, supprimer, repondre, demander, decider, interesse. */
export const reunionEcrire = (action, data = {}) => appeler("reunionEcrire", { ...data, action });

/**
 * Une ligne « Je suis intéressé(e) » (miroir de ligneInteret,
 * functions/lib/ecrituresActivite.js, parité tenue par
 * src/ecrituresActivite.test.js) : posée par le membre lui-même, elle
 * n'ouvre aucun droit avant que l'équipe ou l'organisateur l'accepte
 * (décision de Pierre du 21/10/2026).
 */
export function ligneInteret(l) {
  if (!l || typeof l !== "object") return false;
  if (l.ajouteVia === "interet") return true;
  return !l.ajouteVia && l.type === "delegue" && typeof l.repas === "boolean" && !l.delegateId && !l.participantId
    && !Object.prototype.hasOwnProperty.call(l, "optionnel") && !Object.prototype.hasOwnProperty.call(l, "entreprise");
}
/** Un intérêt que l'équipe n'a pas encore accepté. */
export const interetEnAttente = (l) => ligneInteret(l) && !l.interetAccepteLe;
